<template>
  <div class="sdiv mb40 mb10 dinline-block cpointer br2" @click="goContent(item.id)">
    <div class="igs dinline-block vtop ofhidden">
      <img :src="item['picture'][0]" class="trans3" width="130" height="70">
    </div>
    <div class="txt dinline-block vtop pl15">
      <div class="nm fs18 fbold mb5 ofhidden">{{item.title}}</div>
      <div class="ot tc9 ofhidden">{{item.content|clearHtml}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscItem",
  props:[
    'item',
    'num',
  ],
  methods:{

    goContent(id){
      this.$router.push({path:'/evn/detail',query:{article_id:id,num:this.num}});
    },
  },
  filters: {
    clearHtml(html) {
      html = html.replace(/<.*?>|<\.*?>/ig, "");
      html = html.replace(/(\&.*;)/ig, "");
      return html
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/DiscItem.vue